<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<!-- <ng-container *ngIf="isScreenSmall">
    <fuse-vertical-navigation
        class="dark bg-gray-900 print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="false">
        <ng-container fuseVerticalNavigationContentHeader>
            <div class="flex items-center h-20 pt-6 px-8">
                <img
                    class="w-24"
                    src="assets/images/logo/logo-text-on-dark.svg"
                    alt="Logo image">
            </div>
        </ng-container>
    </fuse-vertical-navigation>
</ng-container> -->

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div *transloco="let t" #header>
      <div class=" relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
          <ng-container *ngIf="!isScreenSmall">
              <!-- Logo -->

              <!-- <div   class="flex items-center mx-2 lg:mr-8">
                  <div class="hidden lg:flex">
                      <img
                      *ngIf="errorImageIsologo === false"
                          class="dark:hidden w-64"
                          [src]="folderImageIsologo + nameImageIsologo" (error)="errorImageIsologo = true">
                      <img *ngIf="errorImageIsologo === false"
                          class="hidden dark:flex w-64"
                          [src]="folderImageIsologo + nameImageIsologo" (error)="errorImageIsologo = true">
                  </div>
                  <img *ngIf="errorImageIsologo === false"
                      class="flex lg:hidden w-64"
                      [src]="folderImageIsologo + nameImageIsologo" (error)="errorImageIsologo = true">
              </div> -->

              <div   class="flex items-center mx-2 lg:mr-8">
                <div class="hidden lg:flex">
                    <img
                    *ngIf="errorImageIsologo === false"
                        class="dark:hidden w-64"
                        src="./../../../../../assets/images/isologo/reservatrix-negro-y-naranja-con-fondo-Transparente.png" (error)="errorImageIsologo = true"> <!--Logo-->
                    <img *ngIf="errorImageIsologo === false"
                        class="hidden dark:flex w-64"
                        src="./../../../../../assets/images/isologo/reservatrix-negro-y-naranja-con-fondo-Transparente.png" (error)="errorImageIsologo = true"> <!--Logo-->
                </div>
                <img *ngIf="errorImageIsologo === false"
                    class="flex lg:hidden w-64"
                    src="./../../../../../assets/images/isologo/reservatrix-negro-y-naranja-con-fondo-Transparente.png" (error)="errorImageIsologo = true"> <!--Logo-->
            </div>

            <!-- <div   class="flex items-center mx-2 lg:mr-8">
              <div class="hidden lg:flex">
                  <img
                  *ngIf="errorImageIsologo === false"
                      class="dark:hidden w-64"
                      src="./../../../../../assets/images/isologo/CocoTravelExpressAZULingles.png" (error)="errorImageIsologo = true">
                  <img *ngIf="errorImageIsologo === false"
                      class="hidden dark:flex w-64"
                      src="./../../../../../assets/images/isologo/CocoTravelExpressAZULingles.png" (error)="errorImageIsologo = true">
              </div>
              <img *ngIf="errorImageIsologo === false"
                  class="flex lg:hidden w-64"
                  src="./../../../../../assets/images/isologo/CocoTravelExpressAZULingles.png" (error)="errorImageIsologo = true">
          </div> -->


              <!-- Horizontal navigation -->
              <!-- <fuse-horizontal-navigation
                  class="mr-2"
                  [name]="'mainNavigation'"
                  [navigation]="navigation.horizontal"></fuse-horizontal-navigation> -->
          </ng-container>
          <!-- Navigation toggle button -->
          <!-- <ng-container *ngIf="isScreenSmall">
              <button
                  mat-icon-button
                  (click)="toggleNavigation('mainNavigation')">
                  <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
              </button>
          </ng-container> -->
          <!-- Components -->
          <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
              <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen> -->
              
              <!-- <shortcuts></shortcuts> -->
              <!-- <messages></messages>
              <notifications></notifications>
              <button
                  class="lg:hidden"
                  mat-icon-button
                  >
                  <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>
              </button> -->
              <!-- <user></user> -->
              <!-- <search [appearance]="'bar'"></search> -->
              
                <!-- <a [color]="'primary'" routerLink="/">
                  {{t('HeaderToolBarRootHome')}}
                </a> -->
                <button
                    mat-flat-button
                    [color]="colorhomebutton()" routerLink="/">
                    {{t('HeaderToolBarRootHome')}}
                </button>
              
                <!-- <a class="" routerLink="/contact" >
                  {{t('HeaderToolBarRootContact')}}
                </a> -->
                <button
                    mat-flat-button
                    [color]="colorcontactbutton()" routerLink="/contact">
                    {{t('HeaderToolBarRootContact')}}
                </button>

                <button *ngIf="bitCompanyDemo === true" 
                mat-flat-button
                [color]="colorpricingbutton()" routerLink="/pricing">
                {{t('HeaderToolBarRootPricing')}}
                </button>

                <button 
                mat-flat-button *ngIf="bitBranchBlog === true" 
                [color]="colorblogbutton()" routerLink="/blog">
                {{t('HeaderToolBarRootBlog')}}
                </button>
              
              
          <!-- <a routerLink="/auth/sign-up" >login</a> -->
              <languages></languages>

              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon>person</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button  routerLink="/sign-in" [style.background]="colorsigninbutton()" [style.color]="colorsigninbuttonlabel()" mat-menu-item>
                  <mat-icon [style.color]="colorsigninbuttonlabel()" >person_outline</mat-icon>
                  <span>{{t('signin')}}</span>
                </button>
                <button routerLink="/sign-up" [style.background]="colorsignupbutton()" [style.color]="colorsignupbuttonlabel()" mat-menu-item >
                  <mat-icon [style.color]="colorsignupbuttonlabel()" >person_add</mat-icon>
                  <span>{{t('signup')}}</span>
                </button>
              </mat-menu>

              <!-- <button *ngIf="bitCompanyDemo === true" mat-icon-button [matMenuTriggerFor]="menuSettings" aria-label="Example icon-button with a menu">
                <mat-icon>settings</mat-icon>
              </button>
              <mat-menu  #menuSettings="matMenu">
                
                <button routerLink="/demo-sign-up" [style.background]="colorsignupbutton()" [style.color]="colorsignupbuttonlabel()" mat-menu-item >
                  <mat-icon [style.color]="colorsignupbuttonlabel()" >maps_home_work</mat-icon>
                  <span>Demo sign-up</span>
                </button>
              </mat-menu> -->
              
          </div>
      </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto w-full">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!-- <jjva-ngx-whatsapp-button ngx_whatsapp_phone="'{{companyCellPhone}}'" ngx_whatsapp_text="'Whatsapp'"></jjva-ngx-whatsapp-button> -->
    <!-- <button mat-fab shareButton="facebook"
                    #fbBtn="shareButton"
                    [style.backgroundColor]="fbBtn?.color">
      <fa-icon *ngIf="fbBtn" [icon]="fbBtn.icon" size="lg"></fa-icon>
    </button> -->
    <a *ngIf="companyCellPhone" class="whatsapp" type="phone"  href='https://api.whatsapp.com/send?phone={{companyCellPhone}}' target="_blank" data-rel="external">
       <!-- <i class="fa fa-whatsapp whatsapp-icon"></i> -->
       <svg style="color: white" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="whatsapp-icon" viewBox="0 0 16 16"> <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" fill="white"></path> </svg>
    </a>
    
    <footer class="dark text-white" #footer> 
      <div class="py-8 px-6">
        <div class="flex flex-wrap justify-center items-center gap-x-8 gap-y-4">
          <div *ngIf="branchAddress" class="flex items-center">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="home"
                class="w-4 h-4 mr-3" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
              <path fill="currentColor"
                    d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z">
              </path>
            </svg>
            <a href="https://www.google.com.mx/maps/@20.6284684,-87.0830082,16.29z" target="_blank" class="hover:text-gray-300">
              {{branchAddress}}
            </a>
          </div>
    
          <div *ngIf="companyEmail" class="flex items-center">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="envelope"
                class="w-4 h-4 mr-3" role="img" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512">
              <path fill="currentColor"
                    d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z">
              </path>
            </svg>
            <a href='mailto:{{companyEmail}}' class="hover:text-gray-300">
              {{companyEmail}}
            </a>
          </div>
    
          <div *ngIf="companyPhones.length > 0" class="flex items-center">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="phone"
                class="w-4 h-4 mr-3" role="img" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512">
              <path fill="currentColor"
                    d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z">
              </path>
            </svg>
            <ng-container *ngFor="let phone of companyPhones; let last = last" [ngClass]="{last: last}">
              <a href='tel:{{phone}}' data-rel="external" class="hover:text-gray-300">
                {{phone}}
              </a>
              <label class="mr-1 ml-1"  *ngIf="!last">
                {{'/'}}
              </label >
            </ng-container>
          </div>
        </div>
      </div>
  
    <div class="p-4 text-center"> 
      <!-- border-t border-gray-700 -->
      <span>&copy; {{currentYear}} Copyright:</span>
      <a class="font-semibold hover:text-gray-300" routerLink="/"> {{branchFooterText}}</a>
    </div>
  
    <div class="p-4 ">
      <!-- border-t border-gray-700 -->
       <div class="flex justify-center items-center gap-6">
        <a *ngIf="branchFB" href="https://www.facebook.com/{{branchFB}}" target="_blank" class="hover:opacity-75">
          <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-f"
               class="w-4 h-4" role="img" xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 320 512">
            <path fill="currentColor"
                  d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z">
            </path>
          </svg>
        </a>
        <a *ngIf="branchIG" href="https://www.instagram.com/{{branchIG}}/" target="_blank" class="hover:opacity-75">
          <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram"
               class="w-5 h-5" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="currentColor"
                  d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z">
            </path>
          </svg>
        </a>
        <a *ngIf="branchTA" href="https://www.tripadvisor.com.mx/{{branchTA}}" target="_blank" class="hover:opacity-75">
          <svg fill="currentColor" class="w-6 h-6" viewBox="-5 0 40 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>{{branchTA}}</title>
            <path d="M23.49 14.862c0 0 0 0 0 0-1.469 0-2.659 1.191-2.659 2.659s1.191 2.659 2.659 2.659c1.469 0 2.659-1.191 2.659-2.659 0-0.49-0.132-0.948-0.363-1.342l0.007 0.013c-0.468-0.8-1.324-1.33-2.303-1.33 0 0 0 0 0 0v0zM8.505 14.862c0 0 0 0 0 0-1.469 0-2.659 1.191-2.659 2.659s1.191 2.659 2.659 2.659c1.469 0 2.659-1.191 2.659-2.659 0-0.49-0.132-0.948-0.363-1.342l0.007 0.013c-0.468-0.8-1.324-1.33-2.303-1.33v0zM23.49 12.45c0.001 0 0.001 0 0.002 0 2.8 0 5.070 2.27 5.070 5.070s-2.27 5.070-5.070 5.070c-2.8 0-5.070-2.27-5.070-5.070 0-0.933 0.252-1.807 0.691-2.558l-0.013 0.024c0.892-1.527 2.523-2.536 4.39-2.537h0zM8.505 12.447c0 0 0 0 0 0 2.801 0 5.072 2.271 5.072 5.072s-2.271 5.072-5.072 5.072c-2.801 0-5.072-2.271-5.072-5.072 0-0.934 0.252-1.809 0.692-2.56l-0.013 0.024c0.893-1.527 2.525-2.536 4.393-2.536v0zM16 8.821c2.032 0.001 3.966 0.416 5.724 1.165l-0.096-0.036c-3.173 1.090-5.447 3.97-5.628 7.405l-0.001 0.020c-0.18-3.455-2.455-6.336-5.57-7.408l-0.058-0.017c1.662-0.712 3.597-1.126 5.628-1.127h0zM16.008 6.372c-0.002 0-0.005 0-0.007 0-3.565 0-6.873 1.099-9.604 2.978l0.057-0.037h-5.45l2.453 2.668c-1.508 1.376-2.45 3.349-2.45 5.542 0 4.138 3.355 7.493 7.493 7.493 1.971 0 3.764-0.761 5.102-2.005l-0.005 0.004 2.402 2.614 2.402-2.612c1.333 1.239 3.126 2 5.097 2 4.139 0 7.494-3.355 7.494-7.494 0-2.193-0.942-4.167-2.444-5.537l-0.006-0.005 2.453-2.668h-5.436c-2.673-1.841-5.98-2.94-9.545-2.94-0.003 0-0.005 0-0.008 0h0z"></path>
          </svg>
        </a>
        </div>
    </div>
  
  </footer>

</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat>(click)="quickChat.toggle()" -->
